import { useMemo } from 'react';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useCurrentUser } from '#src/app/shared/hooks/session';

type Result = ModelHookResult<{
	replacements: Record<string, string>;
}>;

export function useReplacements(): Result {
	const {
		data: { petition, signaturesFromShareCountEstimateLocalized },
	} = usePsfPromoteOrSharePageData();
	const user = useCurrentUser();

	const guestUserShortDisplayName = useQueryParamValue('short_display_name');

	return {
		data: {
			// eslint-disable-next-line complexity
			replacements: useMemo(() => {
				const country = petition.country.displayName;
				const starter = petition.user;
				const starterCountry = starter.country?.displayName || '';
				const shortDisplayName = (user ? user.shortDisplayName : guestUserShortDisplayName) || '';
				return {
					petition_name: petition.ask,
					petition_name_dm: petition.ask,
					petition_country: country,
					petition_location: [petition.city, petition.state?.shortDisplayName, country].filter(Boolean).join(', '),
					primary_dm_name: petition.decisionMakersConnection.nodes[0]?.displayName || '',
					sharer_name: user?.displayName || '',
					sharer_name_short: shortDisplayName,
					sharer_location: user?.formattedLocationString || '',
					preferredName: shortDisplayName,
					preferred_name: shortDisplayName,
					starter_city_state: starter.formattedLocationString || '',
					starter_city_country: [starter.city, starterCountry].filter(Boolean).join(', '),
					signature_count: petition.signatureState.signatureCount.displayedLocalized,
					signature_target: petition.signatureState.signatureTargetLocalized,
					signaturesFromShareCount: signaturesFromShareCountEstimateLocalized,
				};
			}, [petition, user, guestUserShortDisplayName, signaturesFromShareCountEstimateLocalized]),
		},
	};
}
